module.exports = __webpack_public_path__ + "img/exclamation-circle.394354fb.svg";